/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card[_ngcontent-%COMP%]{width:40%}.title-text[_ngcontent-%COMP%]{letter-spacing:2px;justify-content:center;text-align:center}.close-btn[_ngcontent-%COMP%]{cursor:pointer;font-size:18px}"];
export { styles as styles };
